'use strict';

import './CouponRemainingUses.less';

import React from 'react';
import CouponPropType from './CouponPropType';

export default class CouponRemainingUses extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			remainingUses: this.props.coupon.maxUses()
		};

		this.update = this.update.bind(this);
	}

	async update() {
		const timesUsed = await CK.clientSockets.users.emit('getCouponUseCount', {
			couponId: this.props.coupon.id()
		});

		this.setState({
			remainingUses: this.props.coupon.maxUses() - timesUsed
		});
	}

	componentDidMount() {
		this.updateInterval = setInterval(this.update, 15000);

		this.update();
	}

	componentWillUnmount() {
		clearInterval(this.updateInterval);
	}

	render() {
		let fractionRemaining = this.state.remainingUses / this.props.coupon.maxUses() * 100;

		return (
			<div className="CouponRemainingUses">
				<div className="outerBar">
					<div className="innerBar" style={{ width: fractionRemaining + '%' }} />
				</div>
				<div className="amountText">
					{this.state.remainingUses} remaining discounted plan{this.state.remainingUses !== 1
						? 's'
						: ''}!
				</div>
			</div>
		);
	}
}

CouponRemainingUses.propTypes = {
	coupon: CouponPropType.isRequired
};
